/* eslint-disable react/jsx-max-props-per-line */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@mui/material';
import validate from 'validate.js';
import { DialogDefaultV2, InputV2, SimNaoSelectV2 } from '../../../components/v2';

const LINK_URL_PATTERN = /^https?:\/\/.+/i;

const buildSchema = (linkSistemaExterno) => {
  const schema = {
    fotosVisualizadas: {
      presence: { allowEmpty: false, message: 'é obrigatório' },
      inclusion: {
        within: ['SIM', 'NAO'],
        message: 'é obrigatório',
      },
    },
  };

  if ((linkSistemaExterno || '').trim()) {
    schema.linkSistemaExterno = {
      format: {
        pattern: LINK_URL_PATTERN,
        message: 'informe um link válido (http ou https)',
      },
    };
  }

  return schema;
};

const IniciarDigitacaoModal = ({ open, handlerCancel, handlerConfirm }) => {
  const [errors, setErrors] = useState({});
  const [values, setValues] = useState({
    fotosVisualizadas: '',
    linkSistemaExterno: '',
  });

  const clearForm = () => {
    setErrors({});
    setValues({
      fotosVisualizadas: '',
      linkSistemaExterno: '',
    });
  };

  const onCancelLocal = () => {
    clearForm();
    handlerCancel();
  };

  const onConfirmLocal = () => {
    const validationErrors = validate(values, buildSchema(values.linkSistemaExterno));
    setErrors(validationErrors || {});
    if (!validationErrors || Object.keys(validationErrors).length === 0) {
      clearForm();
      handlerConfirm({
        fotosVisualizadas: values.fotosVisualizadas === 'SIM',
        linkSistemaExterno: (values.linkSistemaExterno || '').trim(),
      });
    }
  };

  const onFieldChange = (event) => {
    const { name, value } = event.target;
    setValues((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={onCancelLocal}
      handlerConfirm={onConfirmLocal}
      title="Iniciar Digitação"
      confirmMessage="Iniciar"
      maxWidth="sm"
      fullWidth
    >
      <Grid container spacing={1} sx={{ pt: 1 }}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            Antes de iniciar, confirme se visualizou as fotos desta inspeção na aba Serviços.
            O link do sistema externo é opcional — informe apenas se possuir.
          </Typography>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <SimNaoSelectV2
            isRequired
            error={!!(errors && errors.fotosVisualizadas)}
            label="Você visualizou as fotos da inspeção?"
            name="fotosVisualizadas"
            onChange={onFieldChange}
            value={values.fotosVisualizadas}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <InputV2
            error={!!(errors && errors.linkSistemaExterno)}
            label="Link pasta/fotos do sistema externo (opcional)"
            name="linkSistemaExterno"
            placeholder="https://..."
            helperText={
              errors && errors.linkSistemaExterno
                ? errors.linkSistemaExterno[0]
                : 'Informe apenas se você tiver o link.'
            }
            showHelperText
            value={values.linkSistemaExterno}
            onChange={onFieldChange}
          />
        </Grid>
      </Grid>
    </DialogDefaultV2>
  );
};

IniciarDigitacaoModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handlerCancel: PropTypes.func.isRequired,
  handlerConfirm: PropTypes.func.isRequired,
};

export default IniciarDigitacaoModal;
